import {
    DEL_ALLDS_RSLTPL,
    CHANGE_DS_RSLTPL,
    CHANGE_CAT_RSLTPL,
    RESET_CELL_RSLTPL,
    CLICK_CELL_RSLTPL,
    CHANGE_SELROW_RSLTPL,
    CHANGE_EXVARCAT_RSLTPL,
    CHANGE_EXVARNAME_RSLTPL,
    CHANGE_EXVARNAMEOPT_RSLTPL,
    CHANGE_DISTS_RSLTPL
} from './actions';

const initData = {
    ds: [
        //ID = データセットID
        //geoDsID = 地質情報ID
        //divNumX = 推定時の分割数X
        //divNumY = 推定時の分割数Y
        //node = 1: {lon: 141, lat: 43, GL: 10}
        //→1 = ノードID
        //→lon = ノード経度
        //→lat = ノード緯度
        //→GL = ノード地点標高
        //elem = {geoID: 1, node: [1, 2, 6, 5]}
        //→geoID = エレメントの地質ID
        //→node = エレメント構成ノードIDの配列 [左上・右上・右下・左下]
        {
            ID: 1,
            geoDsID: 1,
            divNumX: 3,
            divNumY: 2,
            node: {
                1: {lon: 143, lat: 43.2, GL: 10},
                2: {lon: 143.1, lat: 43.2, GL: 10},
                3: {lon: 143.2, lat: 43.2, GL: 10},
                4: {lon: 143.3, lat: 43.2, GL: 10},
                5: {lon: 143, lat: 43.1, GL: 10},
                6: {lon: 143.1, lat: 43.1, GL: 10},
                7: {lon: 143.2, lat: 43.1, GL: 10},
                8: {lon: 143.3, lat: 43.1, GL: 10},
                9: {lon: 143, lat: 43, GL: 10},
                10: {lon: 143.1, lat: 43, GL: 10},
                11: {lon: 143.2, lat: 43, GL: 10},
                12: {lon: 143.3, lat: 43, GL: 10}
            },
            elem: {
                1: {
                    geoID: 1,
                    node: [1, 2, 6, 5],
                    prob: [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1],
                    env: {
                        river:{
                            0: {lon: 141.485420, lat: 43.142192, dist: 800},
                            1: {lon: 141.580366, lat: 43.074700, dist: 900},
                            32: {lon: 141.611086, lat: 43.016784, dist: 1000},
                            33: {lon: 141.615814, lat: 42.943463, dist: 2000},
                            34: {lon: 141.507082, lat: 42.908847, dist: 3000},
                            35: {lon: 141.363367, lat: 42.938618, dist: 4000}
                        },
                        sea: {
                            79: {lon: 141.529999, lat: 42.611222, dist: 5000}
                        },
                        volcano: {
                            86: {lon: 141.326844, lat: 42.759146, dist: 1200}
                        }
                    }
                },
                2: {geoID: 2, node: [2, 3, 7, 6], prob: [0.2, 0.9, 0.4, 0.5, 0.3, 0.3, 0.1, 0.2, 0.1, 0.2, 0.1, 0.9, 0.6], env: {river: {0: {lon: 141.485420, lat: 43.142192, dist: 320}}}},
                3: {geoID: 3, node: [3, 4, 8, 7], prob: [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1], env: {river: {0: {lon: 141.485420, lat: 43.142192, dist: 380}}}},
                4: {geoID: 4, node: [5, 6, 10, 9], prob: [0.2, 0.9, 0.4, 0.5, 0.3, 0.3, 0.1, 0.2, 0.1, 0.2, 0.1, 0.9, 0.6], env: {river: {0: {lon: 141.485420, lat: 43.142192, dist: 440}}}},
                5: {geoID: 5, node: [6, 7, 11, 10], prob: [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1], env: {river: {0: {lon: 141.485420, lat: 43.142192, dist: 400}}}},
                6: {geoID: 6, node: [7, 8, 12, 11], prob: [0.2, 0.9, 0.4, 0.5, 0.3, 0.3, 0.1, 0.2, 0.1, 0.2, 0.1, 0.9, 0.6], env: {river: {0: {lon: 141.485420, lat: 43.142192, dist: 200.5}}}}
            }
        },
        {
            ID: 2,
            geoDsID: 1,
            divNumX: 3,
            divNumY: 2,
            node: {
                1: {lon: 143, lat: 43.2, GL: 10},
                2: {lon: 143.1, lat: 43.2, GL: 10},
                3: {lon: 143.2, lat: 43.2, GL: 10},
                4: {lon: 143.3, lat: 43.2, GL: 10},
                5: {lon: 143, lat: 43.1, GL: 10},
                6: {lon: 143.1, lat: 43.1, GL: 10},
                7: {lon: 143.2, lat: 43.1, GL: 10},
                8: {lon: 143.3, lat: 43.1, GL: 10},
                9: {lon: 143, lat: 43, GL: 10},
                10: {lon: 143.1, lat: 43, GL: 10},
                11: {lon: 143.2, lat: 43, GL: 10},
                12: {lon: 143.3, lat: 43, GL: 10}
            },
            elem: {
                1: {geoID: 13, node: [1, 2, 6, 5]},
                2: {geoID: 12, node: [2, 3, 7, 6]},
                3: {geoID: 11, node: [3, 4, 8, 7]},
                4: {geoID: 10, node: [5, 6, 10, 9]},
                5: {geoID: 9, node: [6, 7, 11, 10]},
                6: {geoID: 8, node: [7, 8, 12, 11]}
            }
        }
    ],
    cat: 'geo',
    cellInfo: {
        dsID: null,
        elemID: null,
        geoID: null,
        prob: []
    },
    selRow: null,
    exVarCat: 'river',
    exVarName: '',
    exVarNameOpt: [],
    dists: []
};

export function rsltPlReducer(state = initData, action) {
    switch (action.type) {
        case DEL_ALLDS_RSLTPL:
            return delAllDsReduce(state, action);
        case CHANGE_DS_RSLTPL:
            return changeDsReduce(state, action);
        case CHANGE_CAT_RSLTPL:
            return changeCatReduce(state, action);
        case RESET_CELL_RSLTPL:
            return resetCellReduce(state, action);
        case CLICK_CELL_RSLTPL:
            return clickCellReduce(state, action);
        case CHANGE_SELROW_RSLTPL:
            return changeSelRowReduce(state, action);
        case CHANGE_EXVARCAT_RSLTPL:
            return changeExVarCatReduce(state, action);
        case CHANGE_EXVARNAME_RSLTPL:
            return changeExVarNameReduce(state, action);
        case CHANGE_EXVARNAMEOPT_RSLTPL:
            return changeExVarNameOptReduce(state, action);
        case CHANGE_DISTS_RSLTPL:
            return changeDistsReduce(state, action);
        default:
            return state;
}
}

export function delAllDsReduce(state) {
    return {
        ...state,
        ds: []
    };
}

export function changeDsReduce(state, action) {
    let ds = state.ds.slice();
    //IDは1オリジン
    ds[action.ds.ID - 1] = action.ds;
    return {
        ...state,
        ds: ds
    };
}

export function changeCatReduce(state, action) {
    return {
        ...state,
        cat: action.value
    };
}

export function resetCellReduce(state) {
    return {
        ...state,
        cellInfo: {
            dsID: null,
            elemID: null,
            geoID: null,
            prob: []
        }
    };
}

export function clickCellReduce(state, action) {
    return {
        ...state,
        cellInfo: {
            dsID: action.dsID,
            elemID: action.elemID,
            geoID: action.geoID,
            prob: action.prob
        }
    };
}

export function changeSelRowReduce(state, action) {
    return {
        ...state,
        selRow: action.rowID
    };
}

export function changeExVarCatReduce(state, action) {
    return {
        ...state,
        exVarCat: action.value
    };
}

export function changeExVarNameReduce(state, action) {
    return {
        ...state,
        exVarName: action.value
    };
}

export function changeExVarNameOptReduce(state, action) {
    return {
        ...state,
        exVarNameOpt: action.opt
    };
}

export function changeDistsReduce(state, action) {
    return {
        ...state,
        dists: action.dists
    };
}